import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-735e3604"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-custom l-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "p-custom__sec" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "p-custom__secin" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "p-custom__message" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "p-custom__txt" }, [
        /*#__PURE__*/_createTextVNode(" 「MEN'S NON-NO WEB」「週プレNEWS」「webスポルティーバ」 の会員システム「集英社メンズマガジン会員」は、2024年6月24日から「集英社ID」と連携しています。"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" サービス連携を解除しますと、3つのサイトでログインができなくなりますのでご注意ください。 ")
      ])
    ])
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}